import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Card } from '../ui/Card';
import type { JiraProject } from '../../types';

function ProgressBar({ value, total }: { value: number; total: number }) {
  const pct = total > 0 ? Math.round((value / total) * 100) : 0;
  return (
    <div className="h-1.5 w-full overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800">
      <div className="h-full rounded-full bg-pulse-500 transition-all" style={{ width: `${pct}%` }} />
    </div>
  );
}

export function ProjectCard({ project, index = 0 }: { project: JiraProject; index?: number }) {
  const donePct = project.issueCounts.total
    ? Math.round((project.issueCounts.done / project.issueCounts.total) * 100)
    : 0;

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25, delay: index * 0.04 }}
    >
      <Link to={`/jira?project=${project.key}`}>
        <Card className="h-full p-5 transition-shadow hover:shadow-md">
          <div className="flex items-start justify-between gap-2">
            <div className="flex items-center gap-3">
              {project.avatarUrl ? (
                <img src={project.avatarUrl} alt="" className="h-9 w-9 rounded-lg" />
              ) : (
                <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-pulse-100 text-xs font-bold text-pulse-700 dark:bg-pulse-900/40 dark:text-pulse-300">
                  {project.key.slice(0, 2)}
                </div>
              )}
              <div>
                <p className="font-semibold text-slate-900 dark:text-white">{project.name}</p>
                <p className="text-xs text-slate-400">{project.key}</p>
              </div>
            </div>
            <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-500 dark:bg-slate-800 dark:text-slate-400">
              {donePct}% done
            </span>
          </div>

          <div className="mt-4">
            <ProgressBar value={project.issueCounts.done} total={project.issueCounts.total} />
          </div>

          <div className="mt-4 grid grid-cols-3 gap-2 text-center">
            <div>
              <p className="text-sm font-bold text-slate-900 dark:text-white">{project.issueCounts.open}</p>
              <p className="text-[11px] text-slate-400">Open</p>
            </div>
            <div>
              <p className="text-sm font-bold text-slate-900 dark:text-white">{project.issueCounts.inProgress}</p>
              <p className="text-[11px] text-slate-400">In progress</p>
            </div>
            <div>
              <p className="text-sm font-bold text-slate-900 dark:text-white">{project.issueCounts.done}</p>
              <p className="text-[11px] text-slate-400">Done</p>
            </div>
          </div>
        </Card>
      </Link>
    </motion.div>
  );
}
